// extracted by mini-css-extract-plugin
export var changeIcon = "_3z-4";
export var container = "_3z-0";
export var divider = "_3z-7";
export var externalLinkIcon = "_3z-1";
export var green = "_3z-5";
export var helpCircleIcon = "_3z-3";
export var iconButton = "_3z-2";
export var red = "_3z-6";